import React from 'react';
import BackButton from './buttons/new/BackButton';

interface FullScreenLayoutProps {
  title: string;
  children: React.ReactNode;
  onBack?: () => void;
  backButtonText?: string;
  className?: string;
  showBackButton?: boolean;
  hideHeader?: boolean;
}

export const FullScreenLayout: React.FC<FullScreenLayoutProps> = ({
  title,
  children,
  onBack,
  backButtonText,
  className = '',
  showBackButton = false,
  hideHeader = false
}) => {
  return (
    <div className={`w-full h-full flex flex-col ${className}`}>
      {/* Header with title and optional back button - only show if not hidden */}
      {!hideHeader && (
        <div className="flex-shrink-0 bg-white">
          <div className="flex items-center justify-between">
            <div className="flex flex-col gap-4">
              {showBackButton && onBack && (
                <BackButton 
                  onClick={onBack} 
                  text={backButtonText}
                />
              )}
              <h1 className="font-bold text-2xl md:text-3xl text-gray-900">
                {title}
              </h1>
            </div>
          </div>
        </div>
      )}
      
      {/* Scrollable content area with padding */}
      <div className="flex-1 w-full overflow-y-auto scrollbar-hide min-h-0">
        <div className="w-full py-4 md:py-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FullScreenLayout; 